import { ActionTree } from 'vuex'
import { StateInterface } from '../index'
import { SystemStateInterface } from './state'
import types from './types'

const actions: ActionTree<SystemStateInterface, StateInterface> = {
  showChooseLanguageDialog({ commit }) {
    commit(types.SET_DISPLAY_CHOOSE_LANGUAGE_DIALOG_STATUS, true)
  },
  hideChooseLanguageDialog({ commit }) {
    commit(types.SET_DISPLAY_CHOOSE_LANGUAGE_DIALOG_STATUS, false)
  },
  setLanguage({ commit }, language: string) {
    commit(types.SET_LOCALE, language)
  },
}

export default actions
